// A small CSV reader for contact imports: quoted fields, embedded commas
// and line breaks, CRLF, and a header row. Column names are matched
// loosely so "Mobile Number" and "phone" both work.

export type ParsedCsv = { headers: string[]; rows: string[][] }

export function parseCsv(text: string): ParsedCsv {
  const rows: string[][] = []
  let row: string[] = []
  let field = ''
  let quoted = false
  const src = text.charCodeAt(0) === 0xfeff ? text.slice(1) : text
  for (let i = 0; i < src.length; i++) {
    const ch = src[i]
    if (quoted) {
      if (ch === '"') {
        if (src[i + 1] === '"') { field += '"'; i++ } else quoted = false
      } else field += ch
      continue
    }
    if (ch === '"') quoted = true
    else if (ch === ',') { row.push(field); field = '' }
    else if (ch === '\n' || ch === '\r') {
      if (ch === '\r' && src[i + 1] === '\n') i++
      row.push(field); field = ''
      if (row.some((f) => f.trim() !== '')) rows.push(row)
      row = []
    } else field += ch
  }
  row.push(field)
  if (row.some((f) => f.trim() !== '')) rows.push(row)
  const headers = (rows[0] ?? []).map((h) => h.trim())
  return { headers, rows: rows.slice(1) }
}

export type ColumnMap = { phone: number; name: number; tags: number }

const phoneNames = ['phone', 'mobile', 'number', 'whatsapp', 'contact', 'tel']
const nameNames = ['name', 'customer', 'full name']
const tagNames = ['tag', 'tags', 'label', 'group', 'segment']

// Guesses which column holds what; -1 when none matches.
export function guessColumns(headers: string[]): ColumnMap {
  const find = (names: string[]) => headers.findIndex((h) => names.some((n) => h.toLowerCase().includes(n)))
  return { phone: find(phoneNames), name: find(nameNames), tags: find(tagNames) }
}

export type ImportRow = { phone: string; name?: string; tags?: string[] }

// Rows ready for the API. Tags in a cell are split on ; or |.
export function toImportRows(rows: string[][], cols: ColumnMap): ImportRow[] {
  return rows.map((r) => {
    const out: ImportRow = { phone: (r[cols.phone] ?? '').trim() }
    const name = cols.name >= 0 ? (r[cols.name] ?? '').trim() : ''
    if (name) out.name = name
    const tags = cols.tags >= 0 ? (r[cols.tags] ?? '').split(/[;|]/).map((t) => t.trim()).filter(Boolean) : []
    if (tags.length) out.tags = tags
    return out
  })
}
